import { useCallback, useEffect, useRef, useState } from 'react';
import { ApiHatasi, api, onbellektenDus, onbellektenOku } from './api.js';

/**
 * Küçük veri çekme kancası. Kütüphane getirmek yerine ihtiyaç kadarını
 * yazıyoruz: yükleniyor / hata / yenile — hepsi bu.
 */
export interface VeriDurumu<T> {
  veri: T | undefined;
  yukleniyor: boolean;
  hata: ApiHatasi | null;
  yenile: () => void;
}

export function useVeri<T>(yol: string | null, bagimliliklar: unknown[] = []): VeriDurumu<T> {
  const [veri, setVeri] = useState<T | undefined>(undefined);
  const [yukleniyor, setYukleniyor] = useState(!!yol);
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [sayac, setSayac] = useState(0);
  const gecerli = useRef(0);

  useEffect(() => {
    if (!yol) { setYukleniyor(false); return; }
    const kimlik = ++gecerli.current;
    /* ELDEKİ SON YANIT ÖNCE BOYANIR — ama istek YİNE DE gider.
       Ekran geçişlerinde her seferinde boş bir "yükleniyor" durumundan
       geçmek uygulamayı yavaş hissettiriyordu (ölçüldü: her geçiş
       53–174 ms boş ekran). Artık varsa eski değer anında görünür,
       taze yanıt gelince yerine geçer. Veri ağdan daha eski KALMAZ;
       yalnız bekleme ekranı kalkar. */
    const eldeki = onbellektenOku<T>(yol);
    if (eldeki !== undefined) { setVeri(eldeki); setYukleniyor(false); } else { setYukleniyor(true); }
    setHata(null);
    api.al<T>(yol)
      .then((s) => { if (gecerli.current === kimlik) { setVeri(s); setYukleniyor(false); } })
      .catch((e: unknown) => {
        if (gecerli.current !== kimlik) return;
        setHata(e instanceof ApiHatasi ? e : new ApiHatasi(0, String(e)));
        setYukleniyor(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yol, sayac, ...bagimliliklar]);

  /* Elle yenilemede saklanan değer de düşürülür: kullanıcı "yenile"
     dediyse ekranda eski bir kare bile görmek istemez. */
  const yenile = useCallback(() => {
    if (yol) onbellektenDus(yol);
    setSayac((s) => s + 1);
  }, [yol]);
  return { veri, yukleniyor, hata, yenile };
}

/** Yazma işlemleri için: gönderiliyor durumu ve hata yönetimi. */
export function useEylem<G, S>(
  calistir: (girdi: G) => Promise<S>,
): { yurut: (girdi: G) => Promise<S | null>; calisiyor: boolean; hata: string | null; hatayiTemizle: () => void } {
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);

  const yurut = useCallback(async (girdi: G): Promise<S | null> => {
    setCalisiyor(true);
    setHata(null);
    try {
      return await calistir(girdi);
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'Beklenmeyen bir hata oluştu');
      return null;
    } finally {
      setCalisiyor(false);
    }
  }, [calistir]);

  return { yurut, calisiyor, hata, hatayiTemizle: () => setHata(null) };
}

export { api, ApiHatasi };
